import React, { useState } from "react";
import { Link } from "react-router-dom";

const PrediabetesResult = () => {
  const [selectedAnswers, setSelectedAnswers] = useState({
    q1: "",
    q2: "",
    q3: "",
    q4: "",
    q5: "",
    q6: "",
    q7: "",
    q8: "",
    q9: "",
    q10: "",
  });

  const [score, setScore] = useState(null); // To store the final risk score

  const handleSelection = (question, answer) => {
    setSelectedAnswers((prevState) => ({
      ...prevState,
      [question]: answer,
    }));
  };

  const calculateScore = () => {
    let totalScore = 0;

    if (selectedAnswers.q1 === "Yes") totalScore += 1;
    if (selectedAnswers.q2 === "Yes") totalScore += 1;
    if (selectedAnswers.q3 >= 45) totalScore += 1;
    if (selectedAnswers.q4 === "Yes") totalScore += 1;
    if (selectedAnswers.q5 === "Male") totalScore += 1;
    if (selectedAnswers.q6 === "Yes") totalScore += 1;
    if (selectedAnswers.q7 > 25) totalScore += 1;
    if (selectedAnswers.q8 > 110) totalScore += 1;
    if (selectedAnswers.q9 > 5.7) totalScore += 1;
    if (selectedAnswers.q10 === "Yes") totalScore += 1;

    setScore(totalScore);
  };

  const getProgressBar = () => {
    const isHighRisk = score >= 6;
    const arrowPosition = isHighRisk ? "25%" : "75%";

    return (
      <div style={{ position: "relative", width: "100%" }}>
        {/* Progress Bar */}
        <div
          style={{
            display: "flex",
            height: "30px",
            width: "100%",
            borderRadius: "10px",
            overflow: "hidden",
          }}
        >
          <div style={{ flex: 1, backgroundColor: "#f44336" }}></div> {/* High Risk - Red */}
          <div style={{ flex: 1, backgroundColor: "#4caf50" }}></div> {/* Low Risk - Green */}
        </div>

        {/* Moving Arrow */}
        <div
          style={{
            position: "absolute",
            top: "-10px",
            left: arrowPosition,
            transform: "translateX(-50%)",
            transition: "left 0.5s ease-in-out",
            width: "0",
            height: "0",
            borderLeft: "10px solid transparent",
            borderRight: "10px solid transparent",
            borderTop: "10px solid black",
          }}
        ></div>

        {/* Labels */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "10px",
            fontSize: "14px",
            color: "black",
          }}
        >
          <div className="font-sm" style={{ textAlign: "center", flex: 1 }}>High risk</div>
          <div className="font-sm" style={{ textAlign: "center", flex: 1 }}>Low risk</div>
        </div>
      </div>
    );
  };

  return (
    <div className="d-flex justify-content-center ">
      <div className="w-90">
        <h1 className="font-lg mb-4 fw-semibold text-center">Pre-diabetes Calculator</h1>

        <table className="prediabetes-table">
          <thead>
            <tr className="font-sm">
              <th>Sr. No.</th>
              <th>Question</th>
              <th>Answer</th>
            </tr>
          </thead>
          <tbody className="font-sm">
            <tr>
              <td className="text-center">1</td>
              <td>
                Do you have a mother, father, sister, or brother with diabetes?
              </td>
              <td className="w-50">
                <button
                  className={`btn-prediabetes-table ${
                    selectedAnswers.q1 === "Yes" ? "btn-selected" : ""
                  }`}
                  onClick={() => handleSelection("q1", "Yes")}
                >
                  Yes
                </button>
                <button
                  className={`btn-prediabetes-table ${
                    selectedAnswers.q1 === "No" ? "btn-selected" : ""
                  }`}
                  onClick={() => handleSelection("q1", "No")}
                >
                  No
                </button>
              </td>
            </tr>
            <tr className="bg-grey-table">
              <td className="text-center">2</td>
              <td>Have you ever been diagnosed with high blood pressure?</td>
              <td>
                <button
                  className={`btn-prediabetes-table ${
                    selectedAnswers.q2 === "Yes" ? "btn-selected" : ""
                  }`}
                  onClick={() => handleSelection("q2", "Yes")}
                >
                  Yes
                </button>
                <button
                  className={`btn-prediabetes-table ${
                    selectedAnswers.q2 === "No" ? "btn-selected" : ""
                  }`}
                  onClick={() => handleSelection("q2", "No")}
                >
                  No
                </button>
              </td>
            </tr>
            <tr>
              <td className="text-center">3</td>
              <td>How old are you?</td>
              <td>
                <input
                  type="text"
                  className="form-control-prediabetes w-25  w-sm-75"
                  placeholder="Enter Age"
                  value={selectedAnswers.q3}
                  onChange={(e) => handleSelection("q3", e.target.value)}
                />
              </td>
            </tr>
            <tr className="bg-grey-table">
              <td className="text-center">4</td>
              <td>
                Are you physically inactive? (Exercising &lt; 3 times a week)
              </td>
              <td>
                <button
                  className={`btn-prediabetes-table ${
                    selectedAnswers.q4 === "Yes" ? "btn-selected" : ""
                  }`}
                  onClick={() => handleSelection("q4", "Yes")}
                >
                  Yes
                </button>
                <button
                  className={`btn-prediabetes-table ${
                    selectedAnswers.q4 === "No" ? "btn-selected" : ""
                  }`}
                  onClick={() => handleSelection("q4", "No")}
                >
                  No
                </button>
              </td>
            </tr>
            <tr>
              <td className="text-center">5</td>
              <td>Are you a Male or a Female?</td>
              <td>
                <button
                  className={`btn-prediabetes-table ${
                    selectedAnswers.q5 === "Male" ? "btn-selected" : ""
                  }`}
                  onClick={() => handleSelection("q5", "Male")}
                >
                  Male
                </button>
                <button
                  className={`btn-prediabetes-table ${
                    selectedAnswers.q5 === "Female" ? "btn-selected" : ""
                  }`}
                  onClick={() => handleSelection("q5", "Female")}
                >
                  Female
                </button>
              </td>
            </tr>
            <tr className="bg-grey-table">
              <td className="text-center">6</td>
              <td>
                Do you have a history of Diabetes / higher blood glucose during
                your pregnancy and/or lactation? (for females only)
              </td>
              <td>
                <button
                  className={`btn-prediabetes-table ${
                    selectedAnswers.q6 === "Yes" ? "btn-selected" : ""
                  }`}
                  onClick={() => handleSelection("q6", "Yes")}
                >
                  Yes
                </button>
                <button
                  className={`btn-prediabetes-table ${
                    selectedAnswers.q6 === "No" ? "btn-selected" : ""
                  }`}
                  onClick={() => handleSelection("q6", "No")}
                >
                  No
                </button>
                <button
                  className={`btn-prediabetes-table ${
                    selectedAnswers.q6 === "Not applicable" ? "btn-selected" : ""
                  }`}
                  onClick={() => handleSelection("q6", "Not applicable")}
                >
                  Not applicable
                </button>
              </td>
            </tr>
            <tr>
              <td className="text-center">7</td>
              <td>What is your BMI?</td>
              <td>
                <input
                  type="number"
                  className="form-control-prediabetes w-25 w-sm-75 me-2"
                  placeholder="Enter BMI"
                  value={selectedAnswers.q7}
                  onChange={(e) => handleSelection("q7", e.target.value)}
                />Kg/m2
              </td>
            </tr>
            <tr className="bg-grey-table">
              <td className="text-center">8</td>
              <td>What is your fasting blood glucose (FBG)? (if done in last 3 months)</td>
              <td className="">
                <input
                  type="number"
                  className="form-control-prediabetes w-25 w-sm-75 mb-2 me-2"
                  placeholder="Enter FBG"
                  value={selectedAnswers.q8}
                  onChange={(e) => handleSelection("q8", e.target.value)}
                /> mg/dL                
                <button
                  className={`btn-prediabetes-table ${
                    selectedAnswers.q8 === "Not done in last 3 months" ? "btn-selected" : ""
                  }`}
                  onClick={() => handleSelection("q8", "Not done in last 3 months")}
                >
                  Not done in last 3 months
                </button>
              </td>
            </tr>
            <tr>
              <td className="text-center">9</td>
              <td>What is your HbA1c % (reported within the last 3 months)?</td>
              <td className="">
                <input
                  type="number"
                  className="form-control-prediabetes w-25 w-sm-75 me-2 mb-2"
                  placeholder="Enter HbA1c"
                  value={selectedAnswers.q9}
                  onChange={(e) => handleSelection("q9", e.target.value)}
                /> %
                <button
                  className={`btn-prediabetes-table  ${
                    selectedAnswers.q9 === "Not done in last 3 months" ? "btn-selected" : ""
                  }`}
                  onClick={() => handleSelection("q9", "Not done in last 3 months")}
                >
                  Not done in last 3 months
                </button>
              </td>
            </tr>
            <tr className="bg-grey-table">
              <td className="text-center">10</td>
              <td>
              Did your Doctor anytime mentioned about your glucose intolerance or do you have glucose intolerance test positive? (if done in last 3 months)
              </td>
              <td className="d-flex align-items-center">
                <button
                  className={`btn-prediabetes-table ${
                    selectedAnswers.q10 === "Yes" ? "btn-selected" : ""
                  }`}
                  onClick={() => handleSelection("q10", "Yes")}
                >
                  Yes
                </button>
                <button
                  className={`btn-prediabetes-table ${
                    selectedAnswers.q10 === "No" ? "btn-selected" : ""
                  }`}
                  onClick={() => handleSelection("q10", "No")}
                >
                  No
                </button>
                <button
                  className={`btn-prediabetes-table ${
                    selectedAnswers.q10 === "Not done in last 3 months" ? "btn-selected" : ""
                  }`}
                  onClick={() => handleSelection("q10", "Not done in last 3 months")}
                >
                  Not done in last 3 months
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <button className="btn_get_started btns btn-animation-blue mx-auto" onClick={calculateScore}>
          Submit
        </button>
        {score !== null && (
          <div className="d-flex justify-content-center align-items-center mt-4">
            <div className="result-container w-75">
              <div className="row">
                <div className="col-xl-4 mt-auto pb-3 mb-auto justify-content-center align-items-center">
                  <div>{getProgressBar()}</div>
                </div>
                <div className="col-xl-8">
                  <h2>Your Score: {score} / 10</h2>
                  <div>
                    {score >= 6 ? (
                      <div className="mt-3">
              
                        <p className="font-xsm">
                        Based on your score, you're likely to have pre-diabetes, but only your doctor can diagnose it for sure. Share your results with your doctor and ask for a simple blood test to confirm them.
                        <br/><br/>Carbohydrate restricted diet is a scientific strategy help Pre-diabetes Reversal. 
                        It's time to <Link to={'/shop'} style={{
    textDecoration: 'none',
    color: 'inherit', // Prevents color change
    display: 'inline-block', // Ensures proper scaling animation
    transition: 'transform 0.2s ease-in-out'
  }}
  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}> <span style={{color: 'var(--theme-color1)', fontWeight: 'bold'}}>Redu</span>ce  <span style={{fontWeight: 'bold', color: 'var(--theme-color)'}}>carb</span>ohydrates </Link> mindfully .......!!!
                        </p>
                        
                      </div>
                    ) : (
                      <div className="mt-3">
                 
                        <p className="font-xsm">
                         Based on your results, you're at low risk for pre-diabetes. Keep up the good work! These healthy habits will help keep your risk low:
                        </p>
                        <div className="custom-list-effectonhealth mb-2 ps-3 text-muted">
                          <div className="custom-list-item-height-two font-xsm">
                            <span className="me-2 bullet_point_black"></span>
                            Get at least 150 minutes of physical activity a week.
                          </div>
                          <div className="custom-list-item-height-two font-xsm">
                            <span className="me-2 bullet_point_black"></span>
                            Eat healthy foods, including lots of fruits and veggies.
                          </div>
                          <div className="custom-list-item-height-two font-xsm">
                            <span className="me-2 bullet_point_black"></span>
                            Drink more water and fewer sugary drinks.
                          </div>
                          <div className="custom-list-item-height-two font-xsm">
                            <span className="me-2 bullet_point_black"></span>
                            Don't Smoke.
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PrediabetesResult;
